export interface ApiSentryErrorContext {
    kind: 'business' | 'http' | 'request';
    method?: string;
    url?: string;
    baseURL?: string;
    status?: number;
    code?: string;
    message?: string;
    workspaceId?: string | null;
}

type ApiSentryReporter = (error: unknown, context: ApiSentryErrorContext) => void;

const API_SENTRY_REPORTED_FLAG = '__salerioApiSentryReported';

let apiSentryReporter: ApiSentryReporter | null = null;

export const setApiSentryReporter = (reporter: ApiSentryReporter | null) => {
    apiSentryReporter = reporter;
};

export const markApiErrorReported = (error: unknown) => {
    if (error && typeof error === 'object') {
        (error as Record<string, unknown>)[API_SENTRY_REPORTED_FLAG] = true;
    }
};

export const hasApiErrorReported = (error: unknown): boolean => {
    return Boolean(
        error
        && typeof error === 'object'
        && (error as Record<string, unknown>)[API_SENTRY_REPORTED_FLAG]
    );
};

export const reportApiError = (error: unknown, context: ApiSentryErrorContext) => {
    if (!apiSentryReporter || hasApiErrorReported(error)) {
        return;
    }

    try {
        apiSentryReporter(error, context);
        markApiErrorReported(error);
    } catch {
        // Sentry reporting must never change API behavior.
    }
};
